import { motion } from "framer-motion";

// Premium iPhone 16 Pro style frame: titanium edge, dynamic island, glass sheen,
// neon glow, optional 3D tilt and floor reflection.
export default function PhoneMockup({
  src,
  alt,
  className = "",
  glow = "violet",
  tilt = 0,
  reflection = false,
  sheen = true,
  island = true,
  testId,
}) {
  const glowColor =
    glow === "cyan" ? "rgba(0,229,255,0.45)" : "rgba(139,92,246,0.5)";

  return (
    <div
      className={`relative ${className}`}
      style={{ perspective: "1600px" }}
      data-testid={testId}
    >
      <motion.div
        initial={{ rotateY: tilt, rotateX: 4 }}
        whileHover={{ rotateY: 0, rotateX: 0, scale: 1.02 }}
        transition={{ type: "spring", stiffness: 120, damping: 18 }}
        style={{ transformStyle: "preserve-3d" }}
      >
        {/* neon glow behind */}
        <div
          className="pointer-events-none absolute inset-6 -z-10 rounded-[3rem] blur-3xl"
          style={{ background: glowColor }}
        />

        {/* titanium frame */}
        <div
          className="relative rounded-[3rem] p-[9px]"
          style={{
            background:
              "linear-gradient(150deg, #3a3a3d 0%, #0c0c0d 35%, #1c1c1f 70%, #050505 100%)",
            boxShadow:
              "0 40px 90px -30px rgba(0,0,0,0.9), inset 0 0 0 1px rgba(255,255,255,0.08)",
          }}
        >
          {/* dynamic island */}
          {island && (
            <div className="absolute left-1/2 top-[16px] z-20 h-[26px] w-[30%] -translate-x-1/2 rounded-full bg-black" />
          )}

          <div className="relative overflow-hidden rounded-[2.5rem] bg-[#050505]">
            <img
              src={src}
              alt={alt}
              loading="lazy"
              draggable="false"
              className="block w-full select-none"
            />
            {/* diagonal glass sheen */}
            {sheen && (
              <div
                className="pointer-events-none absolute inset-0"
                style={{
                  background:
                    "linear-gradient(115deg, rgba(255,255,255,0.14) 0%, rgba(255,255,255,0) 30%, rgba(255,255,255,0) 70%, rgba(255,255,255,0.05) 100%)",
                }}
              />
            )}
          </div>
        </div>
      </motion.div>

      {reflection && (
        <div
          className="pointer-events-none absolute inset-x-6 top-[100%] h-40 origin-top scale-y-[-1] opacity-20"
          style={{
            backgroundImage: `url(${src})`,
            backgroundSize: "cover",
            backgroundPosition: "bottom",
            maskImage: "linear-gradient(to bottom, black, transparent 70%)",
            WebkitMaskImage: "linear-gradient(to bottom, black, transparent 70%)",
            filter: "blur(2px)",
            borderRadius: "2.5rem",
          }}
        />
      )}
    </div>
  );
}
